// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__3d5am","rotation":"style_rotation__76og8"};